import { useEffect, useRef, useState } from "react";

/* Envio del codigo de un boleto FISICO (Modalefectivo / ModalReporte).

   Antes el campo se enviaba solo a los 0.6 s de dejar de escribir: servia para el lector de
   codigo de barras, pero a quien teclea a mano se le enviaba con 1 o 2 numeros (y como la venta
   es de N boletos, ese codigo incompleto ocupaba el lugar). Ahora se distingue:
     - lector de codigo de barras o pegado: los caracteres llegan casi juntos -> se envia a los 0.3 s
     - tecleo a mano con "busqueda automatica" activada -> se envia a los 3 s sin escribir
     - tecleo a mano con la busqueda automatica apagada -> solo con Enter o el boton "Buscar boleto"
*/
export const ESPERA_LECTOR_MS = 300;
export const ESPERA_MANUAL_MS = 3000;
// Un lector escribe un caracter cada pocos ms; una persona, cada 100 ms o mas
const MS_POR_CARACTER_LECTOR = 35;
const LARGO_MINIMO_LECTOR = 4;
const CLAVE_PREFERENCIA = "boletoFisicoBusquedaAuto";

/* Cuanto esperar antes de enviar (null = no enviar solo).
   inicio/ultima: momento del primer y del ultimo cambio del texto actual. */
export function decidirEspera({ valor, inicio, ultima, automatica }) {
    const texto = String(valor || "").trim();
    if (!texto) return null;
    const n = texto.length;
    const esLector = n >= LARGO_MINIMO_LECTOR && (ultima - inicio) / Math.max(1, n - 1) < MS_POR_CARACTER_LECTOR;
    if (esLector) return ESPERA_LECTOR_MS;
    return automatica ? ESPERA_MANUAL_MS : null;
}

const leerPreferencia = () => {
    try { return localStorage.getItem(CLAVE_PREFERENCIA) !== "0"; } catch (_e) { return true; }
};

export default function useEnvioCodigoFisico({ valor, activo, enviar }) {
    const inicio = useRef(0);
    const ultima = useRef(0);
    const enviarRef = useRef(enviar);
    enviarRef.current = enviar;
    const [automatica, setAutomatica] = useState(leerPreferencia);

    // Llamar en el onChange del input con el texto nuevo
    const registrarTecleo = (nuevo) => {
        const ahora = Date.now();
        if (!String(nuevo || "")) { inicio.current = 0; ultima.current = 0; return; }
        if (!inicio.current || String(nuevo).length <= 1) inicio.current = ahora;
        ultima.current = ahora;
    };

    useEffect(() => {
        if (!String(valor || "").trim()) { inicio.current = 0; ultima.current = 0; }
        if (!activo) return undefined;
        const espera = decidirEspera({ valor, inicio: inicio.current, ultima: ultima.current, automatica });
        if (espera === null) return undefined;
        const t = setTimeout(() => enviarRef.current(valor), espera);
        return () => clearTimeout(t);
    }, [valor, activo, automatica]);

    const cambiarAutomatica = (v) => {
        setAutomatica(v);
        try { localStorage.setItem(CLAVE_PREFERENCIA, v ? "1" : "0"); } catch (_e) { /* sin localStorage: solo esta sesion */ }
    };

    return { registrarTecleo, automatica, cambiarAutomatica, segundosManual: ESPERA_MANUAL_MS / 1000 };
}
